import TrainerSearchPage from './TrainerSearchPage';

export default TrainerSearchPage;
